import setSameHeight from '@utils/heightCalculation';
import { useEffect } from 'react';

const useSameHeight = (dependencies = []) => {
  useEffect(() => {
    window.addEventListener('resize', setSameHeight);
    return () => {
      window.removeEventListener('resize', setSameHeight);
    };
  }, []);

  useEffect(() => {
    setSameHeight();
    // biome-ignore lint/correctness/useExhaustiveDependencies: <deps come from above>
  }, dependencies);

  return setSameHeight;
};

export default useSameHeight;
